<script lang="ts">
    import type { LayoutData } from './$types';
    import { page } from '$app/stores';
    import { supportedLocales } from '$lib/i18n/initI18n.js';
    import { setContext } from 'svelte';
    import { LOCALE_CONTEXT_KEY } from '$lib/context.js';

    export let data: LayoutData;

    setContext(LOCALE_CONTEXT_KEY, data.language);
</script>

<svelte:head>
    {#each supportedLocales as locale (locale)}
        <link rel="alternate" hreflang={locale} href="{$page.url.origin}/{locale}{$page.url.pathname.slice(3)}" />
    {/each}
    <!--<link rel="alternate" hreflang="x-default" href="{$page.url.origin}{$page.url.pathname.slice(3)}" />-->
</svelte:head>

<slot />
